import { hideLoader } from '../Actions/Loader.action';

export const catchError = (ex, onError) => (dispatch) => {
    if (ex.response) {
        ex.response.json().then((error) => dispatch(onError(error)));
        dispatch(hideLoader());
    } else {
        dispatch(onError(ex));
        dispatch(hideLoader());
    }
};
